import { Component, OnInit } from '@angular/core';
import { ModalService } from 'src/app/core/services';
import { BaseModal } from 'src/app/core/utils/BaseModal';
import { AdminPermissionI18n } from '../permissions/permissions.component';

@Component({
  selector: 'app-user-detail-modal',
  templateUrl: './user-detail-modal.component.html',
  styleUrls: ['./user-detail-modal.component.sass']
})
export class UserDetailModalComponent extends BaseModal implements OnInit {

  get isValid(): boolean {
    throw new Error('Method not implemented.');
  }
  get lastState(): any {
    throw new Error('Method not implemented.');
  }

  public permissionI18n = AdminPermissionI18n;
  public loading = false;
  public initialState: any;

  constructor(
    modalService: ModalService,
  ) {
    super(modalService);
  }

  ngOnInit(): void {
  }

  onAllSubmited(): Promise<any> {
    throw new Error('Method not implemented.');
  }

}
